export default __webpack_public_path__ + "static/how-to-maximise-a-short-annual-leave-holiday-make-an-itinerary-4094da09e75e3949273c217cfb2a4dc1.jpg";